import { Navigate, useParams, useLocation } from "react-router-dom";

export const RecipeRedirect = () => {
  const { slug } = useParams();
  const location = useLocation();
  
  // Reconstruct the path under /r/ preserving sub-paths like /print or /edit
  const subPath = location.pathname
    .replace(/^\/(recipes?)\/?/, '') // strip /recipes/ or /recipe/
    .replace(/^[^/]+/, '');          // strip the slug, keep /print, /edit etc.
  
  return <Navigate to={`/r/${slug}${subPath}${location.search}`} replace />;
};
